
import { computed, defineComponent, ref } from "vue";
import { useToast } from "vue-toastification";

import { useStore } from "store";
import { submitGameSession } from "api/gameSession.services";
import { GameSessionInput } from "types/gameSession";
import { Player } from "types/player";

import { BaseButton } from "components/atoms";
import { SubmitGameDialog } from "components/organisms";

export default defineComponent({
  components: { BaseButton, SubmitGameDialog },
  name: "Home",
  setup() {
    const isSubmitGameDialogOpen = ref(false);
    const store = useStore();
    const toast = useToast();
    const gameConfig = computed(() => store.state.ui.gameInputConfig);

    const toggleSubmitGameDialog = () =>
      (isSubmitGameDialogOpen.value = !isSubmitGameDialogOpen.value);

    const onGameSessionSubmit = async (gameSession: GameSessionInput) => {
      const requestObj = {
        gameType: gameSession.gameName,
        playerIdsList: gameSession.playersOrder.map(
          (player: Player) => player.playerId
        ),
      };

      // Todo: Move the error handler to the API handlers
      await submitGameSession(requestObj)
        .then(() => {
          toast.success("Game Submitted!");
          toggleSubmitGameDialog();
        })
        .catch((error) => {
          // Catch the infoCodes returned
          const infoCodes = error.response.data.infoCodes;

          // Map them to error toasts
          Object.keys(infoCodes).forEach((code: string) => {
            toast.error(infoCodes[code]);
          });
        });
    };

    return {
      isSubmitGameDialogOpen,
      toggleSubmitGameDialog,
      playersOptions: store.getters.getPlayersInDomain,
      onGameSessionSubmit,
      gameConfig,
    };
  },
});
